import m, { type Vnode } from 'mithril'
import clsx from 'clsx'
import { initMithrilComponent } from '@client-shared/utils/mithril'

import s from './badge.module.scss'

interface Attrs extends m.Attributes {
	type?: 'default' | 'error'
	icon?: Vnode
}

const Badge = initMithrilComponent<Attrs>()

Badge.view = (vnode) => {
	const { type = 'warning', icon, class: add_class } = vnode.attrs

	return m('div', { class: clsx(s.badge_container, add_class), 'data-badge-type': type }, [
		icon,
		m('span', { class: s.badge_text }, vnode.children),
	])
}

export default Badge
